import React from 'react';

import clsx from 'classnames';
import PropTypes from 'prop-types';

import {
    combineClasses,
} from 'wanderu-css';

function TableHead(props) {
    const {
        classes: classesProps = {},
        className,
        component: Component = 'thead',
        componentProps,
        ...otherProps
    } = props;

    const classes = combineClasses(classesProps);

    return (
        <Component
            className={clsx(
                classes.root,
                className,
            )}
            {...componentProps}
            {...otherProps}
        />
    );
}

TableHead.propTypes = {
    classes: PropTypes.object,
    className: PropTypes.string,
    component: PropTypes.elementType,
    componentProps: PropTypes.object,
};

export default TableHead;
